<div class="menu">
  <div class="menu-container" data-testid="menu-container">
    <!-- Breadcrumbs -->
    @if (user) {
    <nav class="breadcrumb">
      <ul class="breadcrumb-list">
        @for (item of breadcrumb(); track $index){

        <li class="breadcrumb-list-item">
          <a
            [routerLink]="item.path"
            class="breadcrumb-list-item-link"
            [class.active]="$index === breadcrumb().length - 1">
            @if (item.icon){
            <ui-inline-svg name="{{item.icon}}"></ui-inline-svg>
            }
            {{ item.title }}
          </a>
        </li>
        }
      </ul>
    </nav>

    } @else {
    {{ 'MENU.LOGIN' | transloco }}
    }

    <!-- Logo -->
    <ui-logo data-testid="header-logo"></ui-logo>

    <!-- Actions -->
    @if (user) {
    <div class="actions">
      <a
        uiTooltip
        [tooltipText]="'MENU.SETTINGS' | transloco"
        [tooltipPosition]="'bottom'"
        [routerLink]="['settings']"
        class="actions-item">
        <ui-inline-svg class="actions-item-icon" [name]="'settings'"></ui-inline-svg>
      </a>

      <ui-button-alert [open]="alertsOpen" (click)="alertsOpen = !alertsOpen"></ui-button-alert>

      <div
        class="user-avatar"
        cdkOverlayOrigin
        #trigger="cdkOverlayOrigin"
        [ngClass]="{ open: userMenuOpen }"
        (click)="triggerMenu($event, trigger)">
        @if (user.image) {
        <img class="user-avatar-img" [src]="user.image" />
        } @else {
        <span class="user-avatar-initials">{{ user.displayName || '' | initials }}</span>
        }
      </div>

      <app-user-menu
        class="user-menu"
        [user]="user"
        (menuClose)="onCloseMenu()"
        #userMenu></app-user-menu>
    </div>
    } @else {
    <ul class="languages" data-testid="language-list">
      <li *ngFor="let lang of availableLanguages">
        <a class="languages-item" (click)="onChangeLanguage(lang)">
          {{ lang }}
        </a>
      </li>
    </ul>
    }
  </div>
</div>
